export default "__VITE_ASSET__uPPbBlfd__"